import { useLayoutEffect, useState } from 'react';
import { dismissBootSplash, isBootSplashPresent } from './dismiss-boot-splash';
import { useSplashStore } from './splash.store';
import { SplashLoader } from './SplashLoader';

/**
 * Owns splash visibility after the static HTML boot splash is gone.
 *
 * During cold start `#mi-boot-splash` covers the viewport. When all blockers clear,
 * it is dismissed once. Later sessions (e.g. logout) use React SplashLoader.
 */
export function SplashOverlay() {
  const blockerCount = useSplashStore((state) => Object.keys(state.blockers).length);
  const [layoutReady, setLayoutReady] = useState(false);
  const [bootSplashPresent, setBootSplashPresent] = useState(isBootSplashPresent);

  useLayoutEffect(() => {
    setLayoutReady(true);
  }, []);

  const bootBlocking = blockerCount > 0 || !layoutReady;

  useLayoutEffect(() => {
    if (!layoutReady || bootBlocking) {
      return;
    }
    if (!isBootSplashPresent()) {
      setBootSplashPresent(false);
      return;
    }
    dismissBootSplash(() => setBootSplashPresent(false));
  }, [layoutReady, bootBlocking]);

  if (bootSplashPresent || isBootSplashPresent()) {
    return null;
  }

  if (!bootBlocking) {
    return null;
  }

  return <SplashLoader />;
}
